module.exports = __webpack_public_path__ + "img/web-P4-1-2.18688e00.svg";